export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: 'v0.0.4',
    date: '2026-02-28',
    title: 'Remote Eyes',
    changes: [
      'Client-side error reporting — browser errors now visible in relay server logs',
      'Dedicated WSS server bypasses cPanel NGINX WebSocket blocking',
      'version.json generated at build time for reliable update notifications',
    ],
  },
  {
    version: 'v0.0.3',
    date: '2026-02-27',
    title: 'PM Bridge',
    changes: [
      'System architecture brief (L1/L2/L3 map for PM)',
      'Failure modes document (13 scenarios with recovery paths)',
      '3 seed ADRs: clean-room rebuild, monorepo, AI co-pilot',
      'PM mirror repo provisioned on ff.newbx.com',
      'One-way sync script for PM visibility',
    ],
  },
  {
    version: 'v0.0.2',
    date: '2026-02-27',
    title: 'Activity Rail + Enhanced Sounds',
    changes: [
      'Activity feed promoted to persistent right-side rail (replaces floating overlay)',
      'Resizable rail with drag handle (200–400px, persisted)',
      'Multi-voice synthesized sounds: warm fill, ka-ching first sale, whale splash',
      'First sale sound setting with toggle in sound settings panel',
      'AI context annotations on 15 money-path files',
    ],
  },
  {
    version: 'v0.0.1',
    date: '2026-02-26',
    title: 'Genesis',
    changes: [
      'Clean-room rebuild from Galactus reference',
      'Pruned views engine, orphaned files, speculative libs (-8,700 lines)',
      'Core trading terminal: Kalshi + Polymarket integration',
      'Market explorer, position tracker, order management',
      'Value dashboard with multi-sport streaming',
      'MM defense system, perf tracker, diagnostics',
      '687 dashboard tests, 72 relay tests',
    ],
  },
];

export const CURRENT_VERSION = changelog[0].version;
